module.exports = __webpack_public_path__ + "static/img/tu4-m.5c7a369b.png";